module.exports = __webpack_public_path__ + "img/2_93.ea11f007.png";